export class DialogBoxDataModel {
    title: string;
    message: string;
    dialogType: string = "YesNo";    //{YesNo - OkOnly - YesNoCancel }
    useColorButton:boolean=true;
    yesTitle:string="بلی";
    noTitle:string="خیر";
    cancelTitle:string="لغو";
    okTitle:string="باشه";
}